import { render, staticRenderFns } from "./tbmAttendSignature.vue?vue&type=template&id=1a0d52f2"
import script from "./tbmAttendSignature.vue?vue&type=script&lang=js"
export * from "./tbmAttendSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a0d52f2')) {
      api.createRecord('1a0d52f2', component.options)
    } else {
      api.reload('1a0d52f2', component.options)
    }
    module.hot.accept("./tbmAttendSignature.vue?vue&type=template&id=1a0d52f2", function () {
      api.rerender('1a0d52f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/tbm/tbmAttendSignature.vue"
export default component.exports